import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";

var RichText = function RichText(_ref) {
  var children = _ref.children,
      dropcap = _ref.dropcap;
  var getClassName = getClassNameFactory("LongformRichText");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(dropcap ? "dropcap" : null)
    })
  }, children);
};

RichText.propTypes = {
  /**
   * Child nodes passed to the component.
   */
  children: PropTypes.node,

  /**
   * Make the first letter of the first <p> larger, and drop it down.
   */
  dropcap: PropTypes.bool
};
RichText.defaultProps = {
  dropcap: false
};
RichText.displayName = "Longform.RichText";
export default RichText;